import Vue from 'vue'
import VueRouter from 'vue-router'
import VueGtag from "vue-gtag"

import Home from '../views/Home.vue'
import ProductList from '../views/Products/ProductList.vue'
import ProductDetails from '../views/Products/ProductDetails.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import Cart from '../views/Products/Cart.vue'
import OrderComplete from '../views/Products/OrderComplete.vue'


import AdminLogin from '../views/Admin/Login.vue'
import MediaLibrary from '../views/Admin/MediaLibrary.vue'
import AdminCreateProduct from '../views/Admin/CreateProduct.vue'
import AdminProductList from '../views/Admin/ProductList.vue'
import AdminEditProduct from '../views/Admin/EditProduct.vue'
import AdminOrderList from '../views/Admin/OrderList.vue'
import AdminEditOrder from '../views/Admin/EditOrder.vue'

import store from '../store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: "/products/:type",
    component: ProductList,
  },
  {
    path: '/about',
    name: 'About',
    component: About,
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart,
  },
  {
    path: '/order-complete',
    name: 'Order Complete',
    component: OrderComplete,
  },
  {
    path: '/products/details/:id',
    name: 'Details',
    component: ProductDetails,
  },
  {
    path: "/admin",
    component: AdminLogin,
    beforeEnter: (to, from, next) => {
      if (store.state.user.loggedIn) {
        next('/admin/products');
      }
      else {
        next();
      }
    }
  },
  {
    path: "/admin/create-product",
    component: AdminCreateProduct,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/admin/products/:id/edit",
    component: AdminEditProduct,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/admin/products",
    component: AdminProductList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/admin/orders",
    component: AdminOrderList,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: "/admin/orders/:id/edit",
    component: AdminEditOrder,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/admin/media-library",
    component: MediaLibrary,
    meta: {
      requiresAuth: true,
    },
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  if (requiresAuth && !store.state.user.loggedIn) {
    next("/admin");
  }
  else {
    next();
  }
})

Vue.use(VueGtag, {
  config: { id: "UA-32895895-2" }
}, router);

export default router
